import { AllowedComponent } from './types';
import { getDisplayName, createMapChildrenTypes } from '../Common/children-map-utils';

export { getDisplayName };

export const mapChildrenTypes = createMapChildrenTypes(AllowedComponent);
